import React from 'react';
import ConversationView from './ConversationView';
import AllConversationView from './AllConversationView';
import MessageWidgetCard from './MessageWidgetCard';

const MessagesWidget = () => {
  const [isConversationDialogOpen, setIsConversationDialogOpen] =
    React.useState(false);
  const [isAllConversationsDialogOpen, setIsAllConversationsDialogOpen] =
    React.useState(false);

  const handleConversationClick = (conversationId: string) => {
    setIsConversationDialogOpen(true);
    window.location.href = `/#/home/messages/${conversationId}`;
  };

  const handleConversationDialogClose = () => {
    setIsConversationDialogOpen(false);
    window.location.href = `/#/home`;
  };

  return (
    <>
      <MessageWidgetCard
        setIsAllConversationsDialogOpen={setIsAllConversationsDialogOpen}
        handleConversationClick={handleConversationClick}
      />

      <ConversationView
        isConversationDialogOpen={isConversationDialogOpen}
        handleConversationDialogClose={handleConversationDialogClose}
      />

      <AllConversationView
        isAllConversationsDialogOpen={isAllConversationsDialogOpen}
        setIsAllConversationsDialogOpen={setIsAllConversationsDialogOpen}
        handleConversationClick={handleConversationClick}
      />
    </>
  );
};

export default MessagesWidget;
